/**
 * ก้อน 3 — ประมวลผลรูปฝั่ง browser (Worker decode รูปเองไม่ได้)
 *  - computePHash: dHash 64-bit (16 hex) จับรูปซ้ำ/รูปแชร์กัน
 *  - compressImage: ย่อ+บีบเป็น JPEG base64 ก่อนส่งขึ้น R2 (กัน payload บวม)
 */

function loadImage(file) {
  return new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); resolve(img); };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error('โหลดรูปไม่สำเร็จ')); };
    img.src = url;
  });
}

/** dHash: ย่อ 9x8, grayscale, เทียบพิกเซลข้าง ๆ ในแต่ละแถว → 64 bit → 16 hex */
export async function computePHash(file) {
  const img = await loadImage(file);
  const w = 9, h = 8;
  const canvas = document.createElement('canvas');
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(img, 0, 0, w, h);
  const { data } = ctx.getImageData(0, 0, w, h);

  const gray = new Array(w * h);
  for (let i = 0; i < w * h; i++) {
    gray[i] = 0.299 * data[i * 4] + 0.587 * data[i * 4 + 1] + 0.114 * data[i * 4 + 2];
  }
  let bits = '';
  for (let y = 0; y < h; y++) {
    for (let x = 0; x < w - 1; x++) {
      const idx = y * w + x;
      bits += gray[idx] < gray[idx + 1] ? '1' : '0';
    }
  }
  // 64 bits → 16 hex chars
  let hex = '';
  for (let i = 0; i < 64; i += 4) hex += parseInt(bits.slice(i, i + 4), 2).toString(16);
  return hex;
}

/** ย่อให้ด้านยาวสุด <= maxDim แล้วบีบเป็น JPEG dataURL */
export async function compressImage(file, maxDim = 720, quality = 0.7) {
  const img = await loadImage(file);
  let { width, height } = img;
  if (Math.max(width, height) > maxDim) {
    const scale = maxDim / Math.max(width, height);
    width = Math.round(width * scale);
    height = Math.round(height * scale);
  }
  const canvas = document.createElement('canvas');
  canvas.width = width; canvas.height = height;
  canvas.getContext('2d').drawImage(img, 0, 0, width, height);
  return canvas.toDataURL('image/jpeg', quality);
}
